import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { Granularity } from '@/lib/timeSeries';

export interface SelfPacedExecMetrics {
  totals: {
    inscritos: number;
    usuarios: number;
    nuevas: number;
    avg_progress: number;
    completados: number;
    activos_30d: number;
    interesados: number;
  };
  series: { bucket: string; inscripciones: number }[];
  routes: {
    program_id: string;
    program_name: string;
    inscritos: number;
    avg_progress: number;
    completados: number;
    interesados: number;
  }[];
  distribution: { orden: number; rango: string; usuarios: number }[];
  orgs: { name: string; inscritos: number; usuarios: number; avg_progress: number }[];
  stalled: {
    full_name: string | null;
    email: string | null;
    org: string | null;
    program_name: string | null;
    pct: number;
    last_activity: string | null;
  }[];
}

/** Métricas globales de rutas de autoaprendizaje para el Panel Ejecutivo. */
export function useExecutiveSelfPacedMetrics(
  from: Date,
  to: Date,
  granularity: Granularity,
  orgId?: string | null,
  enabled = true,
) {
  const fromIso = from.toISOString();
  const toIso = to.toISOString();

  return useQuery({
    queryKey: ['executive-self-paced-metrics', fromIso, toIso, granularity, orgId ?? null],
    enabled,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<SelfPacedExecMetrics> => {
      const { data, error } = await supabase.rpc('get_executive_self_paced_metrics' as any, {
        _from: fromIso,
        _to: toIso,
        _granularity: granularity,
        _org_id: orgId ?? null,
      });
      if (error) throw error;
      return data as unknown as SelfPacedExecMetrics;
    },
  });
}
